import ModalScrim from "./ModalScrim";

/** Create an empty application. Pass programId to attach it to a specific program. */
export default function CreateAppModal({ programId, programName, onClose, onCreate }) {
  const [name, setName] = useState("");
  const [domain, setDomain] = useState("");
  const [criticality, setCriticality] = useState("Important");
  const [sponsor, setSponsor] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const body = { name, domain, criticality, sponsor };
      if (programId) body.program_id = programId;
      await onCreate(body);
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Could not create application");
    } finally {
      setBusy(false);
    }
  };

  return (
    <ModalScrim testId="create-app-modal">
      <form className="modal" onSubmit={submit}>
        <button type="button" className="modal-close" onClick={onClose} aria-label="Close">×</button>
        <p className="kicker">CREATE APPLICATION</p>
        <h2>New decision unit</h2>
        {programId ? (
          <p className="muted small-note" data-testid="create-app-program">
            Added to program <strong>{programName || programId}</strong>. Empty WHY, no wave, no GO package.
          </p>
        ) : (
          <p className="muted small-note">Empty WHY, no wave, no GO package. Seed theatre is not copied.</p>
        )}
        <label>Name<input data-testid="create-app-name" required value={name} onChange={(e) => setName(e.target.value)} /></label>
        <label>Domain<input data-testid="create-app-domain" required value={domain} onChange={(e) => setDomain(e.target.value)} /></label>
        <label>Criticality
          <select data-testid="create-app-criticality" value={criticality} onChange={(e) => setCriticality(e.target.value)}>
            {["Business critical", "Important", "Standard", "Low"].map((item) => <option key={item}>{item}</option>)}
          </select>
        </label>
        <label>Sponsor<input data-testid="create-app-sponsor" value={sponsor} onChange={(e) => setSponsor(e.target.value)} placeholder="Named owner" /></label>
        {err && <div className="error-message">{err}</div>}
        <button data-testid="create-app-submit" className="primary-button full" type="submit" disabled={busy}>
          {busy ? "Creating…" : "Create application"}
        </button>
      </form>
    </ModalScrim>
  );
}
